import * as React from 'react';

const TaWelcomeText = () => {
	return (
		<div>
			<div className='ta-welcome-page_title'>
				Customer support tech stack assessment
			</div>
			<div className='ta-welcome-page_subtitle'>
				Grade your support tech stack in minutes.
			</div>
			<div className='ta-welcome-page_description'>
				See how you rank against top industry pain points and get tips
				on how to improve your tools and efficiency.{' '}
				<span className='ta-bold ta-italic'>Mic drop.</span>
			</div>
		</div>
	);
};

export default TaWelcomeText;
